import { Injectable } from '@angular/core';
import { PointData } from '@checkout-v2/const';
import { GeocodeResult } from '@yandex-maps/const';
import { BehaviorSubject } from 'rxjs';

export interface GeoObject {
  geocodeResult: GeocodeResult;
  exactPoint?: PointData;
}

@Injectable()
export class DeliveryAddressDialogComponentService {
  suggestedCoords$ = new BehaviorSubject<ymaps.Coordinate>(undefined);
  geoObject$ = new BehaviorSubject<GeoObject>(null);

  pintMapToCoord(coordinates: ymaps.Coordinate): void {
    this.suggestedCoords$.next(coordinates);
  }

  setGeoObject(geoObject: GeoObject): void {
    this.geoObject$.next(geoObject);
  }
}
